import * as yup from 'yup';

import { validateCheckbox } from 'schema/validation/checkbox';

export const BID_STATUS = {
    APPROVED: 'approved',
    ACCEPTED: 'accepted',
    REJECTED: 'rejected',
    UNDER_REVIEW: 'under_review',
    SUBMITTED: 'submitted'
};

export const BidSchema = yup.object().shape({
    acceptedClosingCosts: yup.array().test('Acknowledgement of closing costs is required', validateCheckbox),
    address: yup.string().required('Property Address is required'),
    homeAddress: yup.string().required('Your home address is required'),
    parcelNumber: yup.string().required('Parce Number is required'),
    name: yup.string().required('Name is required'),
    company: yup.string(),
    orgOrCompanyControlling: yup.string(),
    propertyUse: yup.string().required('Property Use is required'),
    plannedImprovements: yup.string().required('Property improvements is required'),
    timeline: yup.string(),
    improvementCosts: yup.string().required('Projected improvement costs is required'),
    fundingMethod: yup.string().required('Funding method is required'),
    communitySupport: yup.string(),
    delinquentPropertyTaxes: yup.string(),
    additionalRealEstateOwnership: yup.string(),
    plannedImprovementsRequiresFinancingDocumentation: yup
        .string()
        .required('Planned improvement cost estimate is required'),
    amount: yup.string().required('Amount is required'),
    email: yup.string().required('Email is required')
});
